import { render, staticRenderFns } from "./_template.vue?vue&type=template&id=c55b2a28&"
import script from "./_template.vue?vue&type=script&lang=js&"
export * from "./_template.vue?vue&type=script&lang=js&"
import style0 from "./_template.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports